import { render, staticRenderFns } from "./StaffDetailV2.vue?vue&type=template&id=ce10dbec&scoped=true"
import script from "./StaffDetailV2.vue?vue&type=script&lang=js"
export * from "./StaffDetailV2.vue?vue&type=script&lang=js"
import style0 from "./StaffDetailV2.vue?vue&type=style&index=0&id=ce10dbec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce10dbec",
  null
  
)

export default component.exports